import { useState } from 'react';
import { useDealstackFeatureFlag } from '@dealstack/frontend/shared/hooks/useDealstackFeatureFlag/useDealstackFeatureFlag.hook.ts';
import { usePermissionRequest } from '@dealstack/frontend/shared/components/PermissionWrapper/PermissionWrapper.tsx';
import { FEATURE_FLAG } from '@dealstack/shared/lib/common/featureFlag.ts';
import { BankAccountLifecycleDebugDrawer } from './BankAccountLifecycleDebugDrawer.tsx';

// Debug-only wiring (MIP-2656): hosts pass `onInspect` to BankAccountTile and render
// `drawer`. Undefined while the BANK_ACCOUNT_STATUS flag is off, which also hides the
// tile's debug button. Delete this folder and the two host lines to remove the tool.
export const useBankAccountLifecycleDebug = () => {
	const { value: lifecycleEnabled } = useDealstackFeatureFlag(FEATURE_FLAG.BANK_ACCOUNT_STATUS);
	// An empty permission request is only satisfied by the internal DEALSTACK_SUPPORT
	// role, so this resolves to "is a support account".
	const { hasPermission: isSupportUser } = usePermissionRequest({});
	const [debugBankAccountId, setDebugBankAccountId] = useState<string | null>(null);

	const drawer = (
		<BankAccountLifecycleDebugDrawer
			bankAccountId={debugBankAccountId ?? ''}
			opened={!!debugBankAccountId}
			onClose={() => setDebugBankAccountId(null)}
		/>
	);

	return {
		onInspect:
			lifecycleEnabled && isSupportUser
				? (bankAccount: { id: string }) => setDebugBankAccountId(bankAccount.id)
				: undefined,
		drawer,
	};
};
